import createImageInnerParallax from '../anims/ImageInnerParallax'
import createImageDezoom from '../anims/ImageDezoom'
import store from '../util/store'

export default class Images {
  constructor() {
    if (store.detect.isMobile) return;

    this._getElems()
    this._imagesInnerParallax()
    this._imagesDezoom()
  }

  _getElems() {
    this.imagesParallax = Array.from(document.querySelectorAll('.image.--parallax')).map((container) => ({
      container,
      image: container.querySelector('.image__inner')
    }))

    this.imagesDezoom = Array.from(document.querySelectorAll('.image.--dezoom')).map((container) => ({
      container
    }))
  }

  _imagesInnerParallax() {
    if (this.imagesParallax) {
      this.imagesParallax.forEach(({container, image}) => {
        createImageInnerParallax({
          container,
          image,
          start: container.dataset.gsapStart || 'top bottom',
          end: container.dataset.gsapEnd || 'bottom top',
          position: container.dataset.gsapPosition || 'top'
        })
      })
    }
  }

  _imagesDezoom() {
    if (this.imagesDezoom) {
      this.imagesDezoom.forEach(({container}) => {
        createImageDezoom({
          container
        })
      })
    }
  }
}
